var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg4Tablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 770,
    height: 856,
    viewBox: "0 0 770 856",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_110481)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 564.156,
    cy: 823.756,
    rx: 564.156,
    ry: 823.756,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 940.172 47.6094)",
    fill: "url(#paint0_linear_447_110481)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_110481",
    x: -473.719,
    y: -229.455,
    width: 2489.54,
    height: 2565.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 279,
    result: "effect1_foregroundBlur_447_110481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_110481",
    x1: 564.156,
    y1: 0,
    x2: 564.156,
    y2: 1647.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#434BEE",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4Tablet);
export default __webpack_public_path__ + "static/media/bg4-tablet.b5e277924faae77604d5b7b84f2e41a0.svg";
export { ForwardRef as ReactComponent };